import * as React from 'react';
import { SVGProps } from 'react';

const SvgRadiologyOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <g clipPath="url(#a)">
      <path
        d="M16 4a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h8Zm-4 2a1 1 0 0 0-1 1v.037c-1.461.108-2.92.454-4.371 1.035a1 1 0 0 0 .742 1.856 12.7 12.7 0 0 1 3.63-.885v1.013c-1.157.128-2.308.48-3.448 1.05a1 1 0 1 0 .894 1.788c.859-.429 1.709-.702 2.553-.823v1.02c-.865.158-1.718.52-2.555 1.077a1 1 0 0 0 1.11 1.664 5.133 5.133 0 0 1 1.445-.69V17a1 1 0 1 0 2 0v-1.858c.473.134.953.362 1.445.69a1 1 0 0 0 1.11-1.664c-.836-.557-1.69-.92-2.555-1.077v-1.02c.844.12 1.694.394 2.553.823a1 1 0 1 0 .894-1.788c-1.14-.57-2.29-.922-3.447-1.05V9.043c1.205.105 2.414.4 3.629.885a1 1 0 0 0 .742-1.856A14.643 14.643 0 0 0 13 7.037V7a1 1 0 0 0-1-1Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgRadiologyOutlined;
